import React, { useState } from 'react';
import { MdInfo } from 'react-icons/md';
import { ListResultsProps } from 'app/area/experience-transfer/list/types-store';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { Link } from 'react-router-dom';
import { replaceTemplateString } from 'app/infrastructure/platform';
import { Tag } from 'app/components/tag';
import { routeConstants } from 'app/routes/route-constants';
import { ModalWrapper } from 'app/components/modal-wrapper/modal-wrapper';
import styles from './list-results-mobile.scss';
import { isDisabled } from 'app/infrastructure/data/date';

export const ListResultsMobile: React.FC<ListResultsProps> = ({
  listItems, deletingExperienceTransfer, deleteExperienceTransfer, translation
}) => {

  const [criteriaOpen, setCriteria] = useState(false);
  const toggleModal = () => setCriteria(!criteriaOpen);

  return <div className={styles.mobileView}>
    <table>
      {listItems.map(item => <tbody>
          <tr>
            <th>{translation.subscriber_group}</th>
            <td>
              {item.subscriberGroupDescription}
              {!item.active || isDisabled(item.subscriberGroupDisabled)
                ? <Tag className={styles.tag}>
                  {translation.inactive}
                </Tag> : null}
              {item.id !== 0 && !deletingExperienceTransfer?.includes(item.id)
                ? <MeatballMenu
                  id={`meatball-${item.id}`}
                  className={styles.meatball}>
                  <li>
                    <Link
                      to={routeConstants.experienceTransferEditFor(item.id)}
                      className="dropdown-item">
                      {translation.open}
                    </Link>
                  </li>
                  <li>
                    <PromptConfirmationModal
                      title={translation.delete_experience_transfer}
                      description={replaceTemplateString(
                        translation.delete_confirmation,
                        item?.id,
                        [
                          item?.subscriberGroupDescription ?? '',
                          item?.criteriaDescription ?? '',
                          item?.caseTypeDescription ?? '',
                          item?.operationDescription ?? '',
                          !item?.active ? translation.inactive : ''
                        ].filter(Boolean).join(' | ')
                      )}
                      continueText={translation.delete}
                      cancelText={translation.cancel}
                      onContinue={() => {
                        deleteExperienceTransfer(
                          item.id,
                          item.subscriberGroupDescription,
                          translation.experience_transfer_deleted
                        );
                      }}>
                      <button type="button"
                        className="dropdown-item"
                        disabled={deletingExperienceTransfer?.includes(item.id)}>
                        {translation.delete}
                      </button>
                    </PromptConfirmationModal>
                  </li>
                </MeatballMenu> : null}
            </td>
          </tr>
          <tr>
            <th>{translation.criteria}</th>
            <td>
              <span>{item.criteriaDescription}</span>
              <button className={styles.btnInfo} onClick={toggleModal}>
                <MdInfo />
              </button>
              {criteriaOpen && <ModalWrapper
                headerTitle={`${translation.criteria}: ${item?.criteriaDescription}`}
                btnCancelTitle={translation.close}
                onClose={toggleModal}>
                {item.criteriaLongDescription}
              </ModalWrapper>}
            </td>
          </tr>
          <tr>
            <th>{translation.case_type}</th>
            <td>{item.caseTypeDescription}</td>
          </tr>
          <tr>
            <th>{translation.operation}</th>
            <td>{item.operationDescription}</td>
          </tr>
        </tbody>)}
    </table>
  </div>;
};
